import {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Routes from '../../routes.js'
import {modalOpen} from "../../redux/actions";

/**
 * Extending next/link to add support for onclick property.
 *
 * @property {function} onclick
 * @property {Boolean} modal bool
 * In case modal is true following two arguments must be provided
 * @property {String} title
 * @property backpage {route, params}
 */
class RouterLink extends Component {
    static propTypes = {
        onclick: PropTypes.func,
        title: PropTypes.string,
        backpage: PropTypes.object,
        scroll: PropTypes.bool
    }
    constructor(props) {
        super(props)
        this.clickHandler = this.clickHandler.bind(this)
    }
    clickHandler(e) {
        /**
         * roxby: check Link's "shallow" property to might be replace "modal" with it
         */
        if (this.props.onclick) {
            this.props.onclick(e)
        }
    }
    render() {
        return (
            <Routes.Link scroll={this.props.scroll} route={this.props.route} params={this.props.params}>
                <a>
                    <div onClick={this.clickHandler} style={{display: 'inline'}}>
                        {this.props.children}
                    </div>
                </a>
            </Routes.Link>
        )
    }
}

RouterLink.defaultProps = {
    scroll: true
}

export default connect()(RouterLink)



// WEBPACK FOOTER //
// components/links/RouterLink.js